

import "./styles.scss";

import { useTranslation } from 'react-i18next';
import { IconLogout, IconMoon, IconSun, IconDownload, IconHelp } from "@tabler/icons-react";

import { Button } from "@fragments";
import { useDownloadApp } from '@features/downloadApp'

import Header from './header'
import UserSelect from './userSelect'
import Search from './search'
import SharePost from './sharePost'
import Communities from './communities'
import AdminSection from './adminSection'
import Wallet from '../Header/wallet'
import CreateButton from '../Header/actions/CreateButton'
import Notifications from '@components/Screen/Header/Notifications'
import ChatFloatingButton from '@components/ChatFloatingButton'
import { useSidebar } from './SidebarContext'
import { useScreen as useScreenLayout } from '../ScreenContext'
import { useScreen } from '@hooks/useScreen'

import config from '@config'

export default function Sidebar() {
    const { t } = useTranslation('shell')
    const { collapsed, isMobile } = useSidebar()
    const { sidebarRef } = useScreenLayout()
    const { resolvedAppearance, setAppearance } = useScreen()
    const downloadApp = useDownloadApp()

    const className = [
        'cs-sidebar',
        collapsed ? 'cs-sidebar--collapsed' : '',
        isMobile ? 'cs-sidebar--mobile' : '',
    ].filter(Boolean).join(' ')

    return (
        <div ref={sidebarRef} className={className}>

            <Header />
            <Search />
            <SharePost />
            <Communities />

            {isMobile && !collapsed && (
                <div className="cs-sidebar-mobile-actions">
                    <Wallet />

                    <div className="cs-sidebar-mobile-actions__row">
                        <Notifications />
                        <Button
                            color="overlay"
                            variant="rounded"
                            icon={resolvedAppearance === 'dark' ? <IconMoon /> : <IconSun />}
                            onClick={() => setAppearance(resolvedAppearance === 'dark' ? 'light' : 'dark')}
                            tooltip={t('actions.changeTheme')}
                        />
                        {/* QR modal on a computer, the device's own store on a phone. */}
                        <Button
                            color="overlay"
                            variant="rounded"
                            icon={<IconDownload />}
                            onClick={downloadApp.open}
                            tooltip={t('actions.downloadApp')}
                            preventLoading
                        />
                        <Button
                            color="overlay"
                            variant="rounded"
                            icon={<IconHelp />}
                            onClick={() => window.open(config.help)}
                            tooltip={t('actions.help')}
                        />
                    </div>

                    <CreateButton fullWidth />
                    <ChatFloatingButton inline />
                    <Button
                        onClick={() => window.logout()}
                        variant="rounded"
                        color="overlay"
                        endIcon={<IconLogout />}
                        fullWidth
                    >
                        {t('actions.logout')}
                    </Button>
                </div>
            )}

            <div className="cs-sidebar-footer mt-5">
                <AdminSection />
                <UserSelect />
            </div>
        </div>
    )
}
